import { render, staticRenderFns } from "./dashboardSvg.vue?vue&type=template&id=03f664f3"
import script from "./dashboardSvg.vue?vue&type=script&lang=js"
export * from "./dashboardSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports